module.exports = __webpack_public_path__ + "img/message-slash.5f848fd7.svg";